import React from 'react';
import { Dropdown } from '../../../Dropdown';
import { MenuVerticalFilled } from '../../../Icon';
import { IconButton } from '../../../IconButton';
import { Menu } from '../../../Menu';
export var AudioMenu = function AudioMenu(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Dropdown, {
    closeOnInsideClick: false,
    trigger: /*#__PURE__*/React.createElement(IconButton, {
      discColor: "transparent",
      component: MenuVerticalFilled,
      color: "secondary.light"
    }),
    position: "bottom",
    anchor: "end"
  }, /*#__PURE__*/React.createElement(Menu, null, children));
};